import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import _ from 'lodash'

import authActions from '../../redux/auth/actions'
import appActions from '../../redux/app/actions'

import LoginForm from '../../components/login/loginForm'

const { login } = authActions
const { toggleAll } = appActions

class Login extends React.Component {
    componentDidMount () {
        this.handleResize = _.debounce(() => {
            this.props.toggleAll(window.innerWidth, window.innerHeight)
        }, 90)
        this.props.toggleAll(window.innerWidth, window.innerHeight)
        window.addEventListener('resize', this.handleResize)
    }

    componentWillUnmount () {
        window.removeEventListener('resize', this.handleResize)
        if (this.handleResize && this.handleResize.cancel) this.handleResize.cancel()
    }

    requestLogin = (values) => {
        this.props.login(values, { onSuccess: () => { location.reload() } })
    }

    render () {
      const { app, auth } = this.props

        if (app.get('height') === 0) {
            return <div />
        }

        return (
            <LoginForm
                auth={auth}
                requestLogin={this.requestLogin} />
        )
    }
}

const mapStateToProps = state => ({
  app: state.get('App'),
  auth: state.get('Auth')
})

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    login,
    toggleAll
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)
